/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { TViewComponent } from "../../../view/IView";
import { AssetEdit } from "./AssetEdit";
import { Layout } from "../../../ui/components/Layout/Layout";
import { AssetEditMain } from "./components/AssetEditMain";
import { AssetInfo } from "./components/AssetInfo";
import { AssetToolbar } from "./components/AssetToolbar";
import { AssetSecondaryToolbar } from "./components/AssetSecondaryToolbar";

export const AssetEditComponent: TViewComponent<AssetEdit> = ({ view }) => {
	const layoutState = useMemo(() => view.getLayout(), []);

	const renderComponent = (componentName: string) => {
		switch (componentName) {
			case "toolbar":
				return <AssetToolbar view={view} />;
			case "secondaryToolbar":
				return <AssetSecondaryToolbar view={view} />;
			case "main":
				return <AssetEditMain view={view} />;
			case "assetInfo":
				return <AssetInfo view={view} />;
			default:
				return <p>Error: Undefined panel {componentName}.</p>;
		}
	};

	return <Layout state={layoutState} renderComponent={renderComponent} />;
};
